(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-discount-code"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Default <form action="/discount/"> with a `discount` input would post
    // to `/discount/?discount=CODE`, but Shopify expects the code as a URL
    // path segment: `/discount/CODE?redirect=/cart`. Intercept the submit
    // and rewrite the URL accordingly.
    var form = document.getElementById('CartDiscountCodeForm');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = document.getElementById('CartDiscountCodeInput');
      if (!input) return;
      var code = (input.value || '').trim();
      if (!code) return;
      var safe = encodeURIComponent(code);
      window.location.href = '/discount/' + safe + '?redirect=/cart';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-free-shipping-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.getElementById('CartFreeShippingBar');
    if (!bar) return;

    var thresholdCents = parseInt(bar.dataset.thresholdCents, 10);
    if (!thresholdCents || isNaN(thresholdCents)) return;

    var fill = document.getElementById('CartFreeShippingFill');
    var msg = document.getElementById('CartFreeShippingMessage');
    if (!fill || !msg) return;

    function formatRemaining(cents) {
      // Always render as $X.XX with two decimals so the message text matches
      // the Liquid-rendered initial state exactly. Dev + prod stores are USD.
      var dollars = cents / 100;
      return '$' + dollars.toFixed(2);
    }

    function updateBar(totalCents) {
      var remaining = thresholdCents - totalCents;
      if (remaining > 0) {
        var pct = Math.round((totalCents / thresholdCents) * 100);
        if (pct > 100) pct = 100;
        if (pct < 0) pct = 0;
        fill.style.width = pct + '%';
        msg.textContent = 'Add ' + formatRemaining(remaining) + ' more for free shipping!';
      } else {
        fill.style.width = '100%';
        msg.textContent = "You've earned free shipping!";
      }
    }

    function refreshFromCart() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && typeof data.total_price === 'number') {
            updateBar(data.total_price);
          }
        })
        .catch(function () {});
    }

    // Dawn dispatches PUB_SUB_EVENTS.cartUpdate ('cart-update') after cart
    // mutations via assets/pubsub.js. The payload may include cartData with
    // total_price for synchronous update; otherwise fall back to /cart.js.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.cartData && typeof event.cartData.total_price === 'number') {
          updateBar(event.cartData.total_price);
        } else {
          refreshFromCart();
        }
      });
    }

    // Also listen for cart-drawer dispatched events in case other surfaces
    // mutate the cart without re-rendering this section.
    document.addEventListener('cart:refresh', refreshFromCart);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // On page load: check sessionStorage; hide before first paint if dismissed
    var dismissed = sessionStorage.getItem('saleBannerDismissed');
    var banner = document.getElementById('cds-sale-banner');
    if (banner && dismissed === 'true') {
      banner.style.display = 'none';
    }

    var closeBtn = document.getElementById('cds-sale-banner-close');
    if (closeBtn && banner) {
      closeBtn.addEventListener('click', function () {
        banner.style.display = 'none';
        sessionStorage.setItem('saleBannerDismissed', 'true');
        // Move focus to next focusable element after banner
        var nextFocusable = document.querySelector('.header-wrapper a, .header-wrapper button');
        if (nextFocusable) {
          nextFocusable.focus();
        }
      });
    }

    // Keyboard: Enter and Space trigger the close button
    if (closeBtn) {
      closeBtn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          closeBtn.click();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
